import { PinComponent, sortPinComponents } from '@lessonup/pins-shared';
import { useMemo } from 'react';

export const useSortPinComponents = (pinComponents: PinComponent[]): PinComponent[] => {
  return useMemo(() => {
    return sortPinComponents(pinComponents);
  }, [pinComponents]);
};
